module.exports = __webpack_public_path__ + "static/media/teams-marketing.d7121bd9.svg";